
// Vue
import { Component } from 'vue-property-decorator';
import { Mixin, Mixins } from 'vue-mixin-decorator';

// Route
import { RouteConsts } from '@/routes/route';

// Store
import StoreModule from '@/store/index';
// Components
import BaseComponent from '@/components/BaseComponent.vue';
import MacketPlaceContainer from '@/components/MacketPlaceContainer.vue';
import BlogContainer from '@/components/BlogContainer.vue';

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate'
]);

@Mixin({
  components: {
    'm-market-place-container': MacketPlaceContainer,
    'm-blog-container': BlogContainer
  }
})
export default class BasePage extends Mixins<BaseComponent>(BaseComponent) {
  beforeRouteLeave(_to: any, _from: any, next: any) {
    StoreModule.showLoader();
    next();
  }
  mounted() {
    StoreModule.hideLoader();
  }
  get routes() {
    return RouteConsts;
  }
}
